<via-help-resources-layout>
    <div class="e-column-layout">
        <div class="e-navigation-column">
            <div class="e-fixed-content">
                <h1 class="e-page-title">Definitions</h1>

                <mat-accordion class="e-definitions-menu" role="navigation">
                    <div *ngFor="let definition of viaDefinitions">
                        <mat-expansion-panel
                            [expanded]="definition.id === selectedDefinitions.id"
                            (opened)="onViaDefinitionSelection(definition.id)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>{{ definition.name }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div *ngFor="let subDefinition of definition.definitions">
                                <button *ngIf="subDefinition.title !== ''" class="e-definition-title" (click)="scrollToElement(subDefinition.selector)">
                                    {{ subDefinition.title }}
                                </button>
                            </div>
                        </mat-expansion-panel>
                    </div>
                    <mat-expansion-panel (opened)="onCategoriesDefinitionSelection()">
                        <mat-expansion-panel-header>
                            <mat-panel-title>CATEGORIES</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let item of categoryMenuItems">
                            <button class="e-definition-title" (click)="onCategoryMenuItemSelection(item)">{{ item.name }}</button>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                
            </div>
        </div>
        <div class="e-content-column" role="main">
            <div *ngIf="selectedDefinitions && !isLoading">
                <via-definitions-content [categoryDefinitions]="selectedDefinitions"></via-definitions-content>
            </div>
        </div>
        <via-loading-spinner *ngIf="isLoading"></via-loading-spinner>
    </div>
</via-help-resources-layout>
